import * as timecardsActions from "./TimeCardsActionTypes";

const intialState = {
  BatchLabel: "",
  invalidClients: [],
  failedClients:[],
  VmsCompletedCount: null,
  EnableAutoCrawl: true,
};

const TimeCardsReducer = (state = intialState, action) => {
  switch (action.type) {
    case timecardsActions.AutoCrawlInvalidClients:
      return {
        ...state,
        invalidClients: action.payload,
      };
    case timecardsActions.AutoCrawlStatus:
      return {
        ...state,
        BatchLabel: action.payload.BatchLabel,
        invalidClients: action.payload.InvalidClients,
        failedClients: action.payload.FailedClients,
        VmsCompletedCount: action.payload.VmsCompletedCount,
        EnableAutoCrawl:
          action.payload.BatchLabel == "Auto Crawl Process Not Completed" ||
          action.payload.BatchLabel == "Error Occured"
            ? true
            : false,
      };
    default:
      return state;
  }
};

export default TimeCardsReducer;


//Data Validation Reducer
const DV_InitialState = {
  DV_ConsolidationReport: [],
};

export const DV_Reducer = (state = DV_InitialState, action) => {
  switch (action.type) {
    case timecardsActions.DataValidationConsolidation:
      return {
        ...state,
        DV_ConsolidationReport: action.payload,
      };
    default:
      return state;
  }
};

//ReConsolidation Clients Reducer
const ReConsolidationClients_InitialState ={
  ReConsolidationClients:[]
}

export const ReConsolidationClients_Reducer = (state=ReConsolidationClients_InitialState, action) =>{
  switch(action.type){
    case timecardsActions.FetchReConsolidationClients:
      return {
        ...state,
        ReConsolidationClients:action.payload
      };
    default:
      return state;
  }
}

//ReConsolidation Client Header Data Reducer
const ReConsolidationClientHeaderData_InitialState ={
  ReConsolidationClientHeaderData:{}
}

export const ReConsolidationClientHeaderData_Reducer = (state=ReConsolidationClientHeaderData_InitialState, action) =>{
  switch(action.type){
    case timecardsActions.FetchReConsolidationClientHeaderData:
      return {
        ...state,
        ReConsolidationClientHeaderData:action.payload
      };
    case timecardsActions.OnChangeClientHeader:
      return{
        ...state,
        ReConsolidationClientHeaderData:action.payload
      }
    case timecardsActions.UpdateClientHeader:
      return{
        ...state,
        ReConsolidationClientHeaderData:action.payload
      }
    default:
      return state;
  }
}